import api from "./axios";

export const checkHealth = async (endpoint) => {
    try {
        const response = await api.post(endpoint);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Hata" };
    }
};

export const getQueueStatus = async () => {
    try {
        const response = await api.get('api/v1/Queue/status');
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Hata" };
    }
};
